import { ActionComponentType } from "../../constants/ActionComponentType";
import { ActionComponent } from "./ActionComponent";

export class ProtocolComponent{
    actionList: Array<string> = [];
    actionMap: any = {};
    start: ActionComponent = new ActionComponent();
    end: ActionComponent = new ActionComponent();
    
    constructor(startName: string="", endName: string=""){
        this.start.name = startName;
        this.start.actionType = ActionComponentType.NORMAL;
        this.start.timerLen = 0;
        this.end.name = endName;
        this.end.actionType = ActionComponentType.NORMAL;
        this.end.timerLen = 0;
    }
}